import { Component, OnInit, Inject, Input } from '@angular/core';
// import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'rm-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.css']
})
export class TrackingComponent implements OnInit {
  gcp: string;
  gln: string;
  tracking: string;
  hideToolbar: boolean = true;
  record: any;

  constructor(
    private dialogRef: MatDialogRef<TrackingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.gcp = this.data.gcp;
    this.gln = this.data.gln
    this.tracking = this.data.tracking;
    this.record = this.data.record
  }

  cancel() {
    this.dialogRef.close();
  }

}